<template>
  <div class="lucky">
    <div class="history" @click="cardbag">
      <img src="@/assets/icon_right.png" alt="">领奖记录
    </div>
    <lucky-wheel :prizeList="prizeList" ref="wheel" @start="handleStart" @end="handleEnd"/>
    <div class="rule">
      <div class="title">活动规则</div>
      <ul class="desc">
        <li>每个用户每天可免费抽3次</li>
        <li>当天的抽奖资格如未使用，则过期作废，每日24点刷新数据</li>
        <li><span>当天抽中的奖券当天有效，如未使用，过期作废，每日24点刷新数据</span></li>
        <li>每张奖券不可叠加，每次只能使用一张。购买学堂专辑时默认勾选。</li>
      </ul>
    </div>
    <div class="alert-container" v-show="showAlert" @click="handleClose">
      <div class="alert-content">
        <div class="close"><img src="@/assets/icon_close.png" @click="handleClose"></div>
        <div class="title">恭喜你</div>
        <div class="prize">{{ prize.prompt }}</div>
        <div v-show="prize.prize_type == 1" class="button" @click.stop="cardbag">去看看</div>
      </div>
    </div>
  </div>
</template>

<script>
import LuckyWheel from "@/components/LuckyWheel"
import { prizeInfo, lottery } from "@/api/lucky"
export default {
  name: 'Lucky',
  components: {
    LuckyWheel
  },
  data() {
    return {
      prizeList: [],
      count: 3,
      index: -1,
      prize: {},
      showAlert: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      prizeInfo().then((response)=>{
        this.prizeList = response.data.data
      })
    },
    handleStart() {
      lottery().then((response)=>{
        var data = response.data.data
        for(var key in this.prizeList){
          if(this.prizeList[key].id == data.id){
            this.index = key
            this.$refs.wheel.beginRotate(this.index)
            return
          }
        }
        // 弹出再接再厉的弹出框
        this.prize = {id: -1, prompt: '再接再厉'}
        this.showAlert = true;
      }).catch(error=>{
        if(error.message != 'Error'){
          this.$router.push({path: '/login', query: { scene: error.message==311?'bind':'login', redirect: this.$route.fullPath}})
        }
      })
    },
    handleEnd() {
      this.prize = this.prizeList[this.index]
      console.log(this.prize)
      // 弹出中奖框
      this.showAlert = true;
    },
    random (max, min = 0) {
      return parseInt(Math.random() * (max - min + 1) + min)
    },
    cardbag() {
      this.$router.push({path: '/cardbag'})
    },
    handleClose() {
      this.showAlert = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.lucky{
  padding-top: 24vh;
  background: url("~@/assets/luck-bg.png") no-repeat center top;
  background-size: 100%;
  min-height: 76vh;
  .history{
    color: #FFE30A;
    display: flex;
    flex-direction:row-reverse;
    img{
      margin: 0 6px 0 8px;
    }
  }
  .rule{
    color: rgba(255, 255, 255, 0.651);
    .title{
      color: #FE302C;
      font-size: 19px;
      margin-bottom: 18px;
      margin-top: 43px;
    }
    .desc{
      text-align: left;
      padding: 0 18px 32px 32px;
      font-size: 14px;
    }
  }
  .alert-container{
    position:absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(5, 5, 5, 0.555);
    z-index: 10;
    .alert-content{
      width: 80vw;
      background-color: #fff;
      height: 140px;
      margin: 0 auto;
      margin-top: calc(50vh - 70px);
      border-radius: 6px;
      border-top: #FF4848 8px solid;
      color: #333;
      .close{
        text-align: right;
        padding: 8px 5px 0 0;
      }
      .prize{
        margin: 13px 0;
        font-size: 16px;
      }
      .button{
        padding: 6px 0;
        border-top: solid #EEE 1px;
      }
    }
  }
}
@media screen and (max-width: 320px){
  .lucky{
    padding-top: 21vh;
    min-height: 79vh;
    .rule{
      .title{
        margin-top: 16px;
      }
    }
  }
}
@media screen and (max-height: 560px){
  .lucky{
    padding-top: 136px;
    min-height: calc(100vh - 136px);
    .rule{
      .title{
        margin-top: 16px;
      }
    }
  }
}
</style>
